import useThriveAuth from 'hooks/useThriveAuth'
import { clearNonPersistingDataInSession } from 'utils/common'
import { useDispatch } from 'react-redux'
import { cleanBookingInfo } from 'state/booking/actions'
import { pageRoutes } from 'constants/routing'
import { getTreatment } from 'utils/treatment'
import { useRouter } from 'next/router'
import { TreatmentFlags, treatmentFlagValues } from 'constants/treatments'
import styles from './index.module.scss'
import useGetTreatment from 'hooks/treatments/useGetTreatment'

const LoggedOutNavItems: React.FC = () => {
  const { loginWithRedirect } = useThriveAuth()
  const router = useRouter()
  const { query } = router
  const isB2bPartnerSelfBookingOn =
    useGetTreatment(TreatmentFlags.B2B_PARTNERSHIP_SELF_BOOKING) ===
    treatmentFlagValues.ON
  const dispatch = useDispatch()

  const handleLogin = () => {
    clearNonPersistingDataInSession()
    dispatch(cleanBookingInfo())

    if (isB2bPartnerSelfBookingOn && query?.partnershipCode) {
      loginWithRedirectForB2bReferral()
    } else {
      loginWithRedirect()
    }
  }

  /*
    Handle login & redirection when we have to set b2b partnership for end user
    based on the b2b partner keyword in url
  */
  const loginWithRedirectForB2bReferral = () => {
    /*
      Add b2b partnership keyword from url to redirect options so that
      we can set b2b partner details state post login
    */
    const returnTo = `${pageRoutes.DASHBOARD_USER_HOME}?partnershipCode=${query.partnershipCode}`
    loginWithRedirect({ appState: { returnTo } })
  }

  const onLoginClick = () => {
    const isBookingDisabled =
      getTreatment(TreatmentFlags.THRIVEWEB_BOOKINGS) ===
      treatmentFlagValues.DISABLE

    if (isBookingDisabled) {
      //Don't login if site is under maintenance and bookings are disabled
      router.push(pageRoutes.UNDER_MAINTENANCE)
    } else {
      //handle user or support login
      handleLogin()
    }
  }

  return (
    <button className={styles.login_button} onClick={onLoginClick}>
      Log in
    </button>
  )
}

export default LoggedOutNavItems
